import { HiClock } from "react-icons/hi2";
import { IoMdCube } from "react-icons/io";
import { FaGift } from "react-icons/fa6";
import { FaCalendar } from "react-icons/fa";
import { formatDateRange } from "../../../helpers/formatter";
import Countdown from "react-countdown";
import { rendererCountDown } from "../../launchpad/utilsIDO";
import { AirdropType } from "../../../type";
import { useNavigate } from "react-router-dom";

const AirdropGridCard = ({
  airdrop,
  isShowbutton = true,
}: {
  airdrop: AirdropType;
  isShowbutton?: boolean;
}) => {
  const currentTime: any = new Date().getTime();
  const startTime = new Date(airdrop?.start_time).getTime();
  const endTime = new Date(airdrop?.end_time).getTime();
  const navigate = useNavigate();

  return (
    <div
      className={`font-Montserrat text-left ${isShowbutton ? "" : "cursor-pointer"}`}
      onClick={() => {
        if (!isShowbutton) navigate(`/airdrop/${airdrop.slug}`);
      }}
    >
      <div className="w-full aspect-[calc(330/185)] relative">
        <div className="absolute right-2 top-2 px-2 py-[6px] bg-customYellow text-white font-semibold uppercase">
          {new Date(airdrop?.start_time).getTime() > new Date().getTime()
            ? "UPCOMING"
            : new Date(airdrop?.end_time).getTime() < new Date().getTime()
              ? "ENDED"
              : "ONGOING"}
        </div>
        <img
          src={airdrop?.background}
          alt="background"
          className="h-full w-full object-cover bg-center"
        />
      </div>
      <div
        className="py-2 px-4 flex items-center justify-between"
        style={{
          background:
            "linear-gradient(90deg, #F8FBFF, rgba(0, 148, 255, 0.3) 100%)",
        }}
      >
        <div className="flex items-center gap-[6px]">
          <HiClock className="h-5 !w-5 text-text-secondary" />
          <div className="text-text-secondary text-sm font-semibold">
            {currentTime < startTime || !startTime || !endTime
              ? "Starts In"
              : "Ends In"}
            :
          </div>
        </div>
        <div className="text-customBlue-600 text-sm font-semibold">
          {startTime && endTime ? (
            <Countdown
              renderer={rendererCountDown}
              date={currentTime < startTime ? startTime : endTime}
            />
          ) : (
            "TBA"
          )}
        </div>
      </div>
      <div
        className={`px-4 ${isShowbutton ? "pb-4" : "pb-8"} pt-2 flex flex-col gap-4 bg-backgroundWhite`}
      >
        <div className="flex items-center gap-2">
          {airdrop?.avatar ? (
            <img
              src={airdrop?.avatar}
              alt=""
              className="h-9 w-9 object-cover object-center"
            />
          ) : (
            <div className="h-9 w-9 rounded bg-customBlue-300"></div>
          )}
          <div className="font-Azonix text-xl leading-[1] text-text-secondary uppercase line-clamp-1">
            {airdrop?.title}
          </div>
        </div>
        <div className="flex flex-col gap-2 text-text-secondary">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <img src="/images/badge-icon.png" alt="" className="w-5 h-5" />
              <div className="text-sm">Winners</div>
            </div>
            <div className="font-semibold text-sm text-right">
              {airdrop.winners.toLocaleString("en-US")}
            </div>
          </div>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <IoMdCube className="h-5 !w-5 text-text-secondary" />
              <div className="text-sm">Network</div>
            </div>
            <div className="flex w-fit gap-2">
              <img
                src={airdrop.token.chain.logo}
                alt="chain"
                className="w-5 h-5 object-contain"
              />
              <div className="font-semibold text-sm text-right">
                {airdrop.token.chain.name}
              </div>
            </div>
          </div>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <FaGift className="h-5 !w-5 text-text-secondary" />
              <div className="text-sm">Total Rewards</div>
            </div>
            <div className="font-semibold text-sm text-right">
              {airdrop?.total_rewards_string}
            </div>
          </div>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <FaCalendar className="h-5 !w-5 text-text-secondary" />
              <div className="text-sm">Date</div>
            </div>
            <div className="font-semibold text-sm text-right">
              {formatDateRange(airdrop.start_time, airdrop.end_time)}
            </div>
          </div>
        </div>
        {isShowbutton && (
          <button
            className="main-button !w-full"
            onClick={() => {
              navigate(`/airdrop/${airdrop.slug}`);
            }}
          >
            View details
          </button>
        )}
      </div>
      <div className="w-full h-auto">
        <img src="/images/line-open.png" alt="" />
      </div>
    </div>
  );
};

export default AirdropGridCard;
